import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../contexts/context';

// Material UI
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Toolbar from '@mui/material/Toolbar';
import Grow from '@mui/material/Grow';
import {Box} from '@mui/material';
import {ScanSlider} from './ScanSlider';
import {AlertCard, ImageCard} from './scanDialogContents';
import {getBrandValue} from "../containers/Utils"

import {useCountDataKeys, useCountImportedValues} from "../components/AppUtils";
import {getAppUrl} from "../containers/AppUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow style={{ transformOrigin: '0 0 0 0' }}
  ref={ref} {...props} />;
});

const ScanDialog = props => {
  const [ state, dispatch ] = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const changedParams = useCountDataKeys();
  const importedParams = useCountImportedValues();

  console.debug("ScanDialog importedParams", importedParams)

  function checkForTagScannerCompatibility_S01() {
    //Check for Owner URLs after scan
    const brandValue = getBrandValue(getAppUrl().toString());
    const brandValueDevice = getBrandValue(state.deviceData.uri);
    if(brandValue === 'kde'){
      // ignore Compatibility Check
      // dispatch({type: 'app/ui/scanDialog/done', value: changedParams });
      return true
    } else{
      //proceed with check
      if(brandValue !== brandValueDevice) {
        console.debug("ScanDialog | brandValue", brandValue);
        console.debug("ScanDialog | brandValueDevice", brandValueDevice);
        return false
      }else{
        return true
      }
    }
  }

  useEffect(() => {
    if (state.uiScanDialog) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [state.uiScanDialog]);

  useEffect(() => {
    switch (state.ndefControl) {
      case "reading":
        console.debug('state.ndefControl === reading')
        if (state.uiNdefState !== "error") {
          dispatch({
            type: 'app/ui/scanDialog/readInitializer',
            value: {
              scanTime:state.deviceData.scanTime,
              changedParams:changedParams
            }
          });
        }
        break;
      case "writing":
        if (state.uiNdefState !== "error") {
          dispatch({
            type: 'app/ui/scanDialog/writeInitializer',
            value: changedParams
          });
        }
        break;
    }

    switch (state.uiNdefState) {
      case "scanning":
        switch(state.deviceData.source) {
          case 'unknown':
          case 'app':
          case 'scan':
            if (state.ndefControl === "writing") {
              dispatch({
                type: 'app/ui/scanDialog/writeInitializer',
                value: changedParams
              });
            }
            break;
          case 'import':
            if (state.ndefControl === "writing") {
              dispatch({
                type: 'app/ui/scanDialog/writeInitializer',
                value: importedParams
              });
            }
            break;
          default:
            break;
        }
        if (state.ndefControl === "reading") {
          console.debug('state.ndefControl === reading')
          dispatch({
            type: 'app/ui/scanDialog/readInitializer',
            value: {scanTime:state.deviceData.scanTime, changedParams: changedParams}
          });
        }
        if (state.ndefControl === "idle") {
          console.debug('state.ndefControl === idle')
          dispatch({
            type: 'app/ui/scanDialog/idleInitializer',
            value: {scanTime:state.deviceData.scanTime, changedParams: changedParams}
          });
        }
        break;
      case "processing":
        dispatch({type: 'app/ui/scanDialog/processing'});
        break;
      case "done":
        console.debug("ScanDialog | uiNdefState is done");

        if (!checkForTagScannerCompatibility_S01()) {
          // Do nothing
          dispatch({type: 'app/ui/scanDialog/incompatibleDevice'});
          dispatch({type: 'ndef/control/setForNewRead'});
          break;
        }

        dispatch({type: 'app/ui/scanDialog/done', value: changedParams });
        dispatch({type: 'ndef/control/idle'});

        /*if (state.ndefControl === "writing") {
          //Reset CountChangeKeys
          dispatch({type: 'ndef/scan/write/done'});
        }*/
        break;
      case "error":
      default:
        console.warn("ScanDialog | uiNdefState is error.");
        // Error handling should be carried out using the App.js scanDialogHandler function
        break;
    }
  }, [state.uiNdefState, state.ndefControl, state.deviceData.scanTime]);

  return (
    <Box sx={{display:"flex", flexDirection:"column", padding:10, overflow:"hidden"}}>
      <Dialog
        fullScreen
        TransitionComponent={Transition}
        onClose={props.abortHandler}
        aria-labelledby="form-dialog-read-scanning"
        open={open} sx={{maxWidth:"100%", overflowX:"hidden"}}
      >
        <Box sx={{ position: 'relative', backgroundColor:"#fff", mb:1 }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              onClick={props.abortHandler}
            >
              <CloseIcon sx={{color:'#3b3b3b'}}/>
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1, color:"#3b3b3b" }} variant="h6" component="div">
              Scan
            </Typography>
          </Toolbar>
        </Box>
        <DialogContent sx={{display:"flex", flexDirection:"column", paddingY:0, alignItems:"center", justifyContent:"center",}}>

           <ImageCard/>
           <AlertCard/>

        </DialogContent>
        <DialogActions sx={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", marginX:3, marginY:0, paddingY: 0, paddingX: 0}}>
          {state.deviceData.scanTime !== "unknown" && state.scanDialog_showModeChanger === true &&
             <ScanSlider
                name="ndefControl"
                // writeDisabled={(Object.keys(state.deviceData.schema).length <= 0)?true:false}
                writeDisabled={false}
                disabled={false}
                ndefControl={state.ndefControl}
             />
          }
        </DialogActions>
        <DialogActions sx={{display:"flex", marginX:3, paddingTop:10, marginBottom:"5px", alignItems:"center", justifyContent:"left", paddingX: 0}}>
          <Button autoFocus onClick={props.abortHandler} color="primary" variant="contained" size='large' sx={{justifySelf:"left", borderRadius:10}} >
            {state.scanDialog_dialogBtnText}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ScanDialog;
